export const GET_ALL_ORGZANIZATIONS = "GET_ALL_ORGZANIZATIONS";
export const START_LOADING_ORGANIZATIONS = "START_LOADING_ORGANIZATIONS";
export const ERROR_LOADING_ORGANIZATIONS = "ERROR_LOADING_ORGANIZATIONS"
export const STOP_LOADING_ORGANIZATIONS = "STOP_LOADING_ORGANIZATIONS";
export const RESET_DATA = "RESET_DATA";
